module.exports = __webpack_public_path__ + "media/pick-answer.c1f4d53d.webm";